import React, { useState, useEffect, useContext } from "react";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
// import { userId, get, post, getCurrentUser, getToken } from "../Helper";
import { db } from "../../firebase";
import Members from "./MemberList";
import ProjectList from "./ProjectList";
import Updates from "./Updates";
import { AuthContext } from "../Auth/Auth";
import projectListData from "../../data/projectListData.json";
import { fetchClubProjects, fetchEnrollments, fetchProjectsByCategory, fetchUpdatesByClub } from "../Helper";

function ClubTabs({ members, clubId, clubCategory }) {
    const [name, SetName] = useState([]);
    const [clubProjects, setClubProjects] = useState([]);
    // const currentUser = getCurrentUser()
    const { currentUser } = useContext(AuthContext);
    const [tabValue, setTabValue] = useState(0);
    const [updates, setUpdates] = useState([]);
    const [enrollments, setEnrollments] = useState([]);
    const [loading, setLoading] = useState(true);
    
    
    

    useEffect(() => {
        async function fetchData() {
            const clubProjectList = await fetchProjectsByCategory(clubCategory)
            setClubProjects(clubProjectList);
            const updatesList = await fetchUpdatesByClub(clubId)
            setUpdates(updatesList);
            const enrollmentsList = await fetchEnrollments()
            setEnrollments(enrollmentsList)
            setLoading(false)
        }
        fetchData();
     
    }, [currentUser?.id, clubId]);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };



    return (
        <>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', marginBottom: 2 }}>
                <Tabs value={tabValue} onChange={handleTabChange} aria-label="club tabs">
                    <Tab label="Projects" />
                    {/* <Tab label="Updates" /> */}
                    <Tab label="Members" />
                </Tabs>
            </Box>

            {tabValue === 0 ? loading ? 'Loading...' : (
                <ProjectList projects={clubProjects} enrollments={enrollments}/>
            ):''}

             {/* {tabValue === 1 ? loading ? 'Loading...' : (
                <Updates updates={updates}/>
            ):''} */}

            {tabValue === 1 ? loading ? 'Loading...' : (
                <Members members={members} clubId={clubId} currentUser={currentUser} />
            ):''}

            

           
        </>
    );
}


export default ClubTabs;
